import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import AuthLayout from "../../components/Auth/AuthLayout";
import SubmitButton from "../../components/Auth/SubmitButton";
import PasswordField from "../../components/Auth/PasswordField";
import { ResetPassword } from "../../service/login";

export default function Index() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const email = searchParams.get("email") || "";

  const [form, setForm] = useState({
    password: "",
    password_confirmation: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.password === "" || form.password_confirmation === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Completa ambos campos de contraseña",
      });
      return;
    }

    if (form.password !== form.password_confirmation) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Las contraseñas no coinciden",
      });
      return;
    }

    setLoading(true);
    ResetPassword({ token, email, ...form })
      .then((response) => {
        setLoading(false);
        if (response.success === false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message || "No se pudo restablecer la contraseña",
          });
          return;
        }
        Swal.fire({
          icon: "success",
          title: "Listo",
          text: "Tu contraseña fue actualizada",
        }).then(() => navigate("/login"));
      })
      .catch(() => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo restablecer la contraseña, intenta de nuevo",
        });
      });
  };

  return (
    <AuthLayout
      title="Crea una contraseña nueva"
      subtitle="Mínimo 8 caracteres. Al guardarla se cierran las sesiones abiertas."
      footer={
        <Link className="auth-footer-link" to="/login">
          Volver a entrar
        </Link>
      }
    >
      <form onSubmit={handleSubmit}>
        <PasswordField
          id="password"
          label="Nueva contraseña"
          value={form.password}
          onChange={handleChange}
          autoComplete="new-password"
        />

        <PasswordField
          id="password_confirmation"
          label="Confirma la contraseña"
          value={form.password_confirmation}
          onChange={handleChange}
          autoComplete="new-password"
        />

        <SubmitButton loading={loading} loadingLabel="Guardando...">
          Guardar contraseña
        </SubmitButton>
      </form>
    </AuthLayout>
  );
}
